"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDiffMinutes;

function getDiffMinutes(date1, date2) {
  return (date2 - date1) / 60000;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/WeeklyCalendar/week/helpers/getDiffMinutes.js
// module id = CoI7
// module chunks = 0